import { Skeleton } from 'antd';
import { useScheduleTiles } from './useScheduleTiles';
import { Tile, Tiles } from './styled';

export default function ScheduleTiles({ tz, today, enabled }) {
  const { tiles, isLoading } = useScheduleTiles({ tz, today, enabled });

  return (
    <Tiles as="dl" aria-label="Scheduling summary" aria-busy={isLoading}>
      {tiles.map((t) => (
        <Tile key={t.key} $alert={t.alert}>
          <dt>{t.label}</dt>
          <dd>
            {isLoading || t.loading ? <Skeleton.Button active size="large" /> : <strong>{t.value}</strong>}
            <span>{t.sub}</span>
          </dd>
        </Tile>
      ))}
    </Tiles>
  );
}
